import React, { useRef } from "react";

import { ExtraClassNames, classNames } from "../../utils/styles";
import {
    ScrollNavItem,
    getNavItemHref,
    onNavItemClicked,
    scrollToLinkTarget,
    useActiveNavItemHref,
} from "./hooks";

import styles from "./MenuItem.module.scss";

export type MenuItemClassNames = ExtraClassNames<
    "menuItem" | "menuItemSelected"
>;

/**
 * Renders an list item within the main ScrollNavMenuBlock component.
 */
export const MenuItem = (props: {
    navItem: ScrollNavItem;
    classNames?: MenuItemClassNames;
}) => {
    const linkRef = useRef<HTMLAnchorElement>(null);
    const onClick = (event: React.MouseEvent) => {
        if (!linkRef.current) {
            return;
        }
        event.preventDefault();
        onNavItemClicked.emit(props.navItem);
        scrollToLinkTarget(linkRef.current);
    };
    const activeNavItemHref = useActiveNavItemHref();
    const href = getNavItemHref(props.navItem);
    const isSelected = activeNavItemHref === href;
    return (
        <li
            className={classNames([
                [styles.menuItem, true],
                [props.classNames?.menuItem, true],
                [props.classNames?.menuItemSelected, isSelected],
            ])}
        >
            <a ref={linkRef} href={href} onClick={onClick}>
                {props.navItem.name}
            </a>
        </li>
    );
};
